export default "__VITE_ASSET__d8763b88__"